import { useState } from 'react'
import { Button, ResourceSelectField, SelectField } from '@krp/ui-kit'
import { sourceOptions, type SourceItem, type SourcesLoad, type SourceKinds } from '../../../shared/sourceOptions'
import type { CashierSourcePolicy } from '../model/types'

export interface CashierSourcePickerProps {
  sources: SourceItem[]
  /** Вид источника: метка (как на плитке), цвет и общий порядок источников; без него вид не показывается. */
  kinds?: SourceKinds
  sourcesLoad?: SourcesLoad
  resourceId: string
  policy: CashierSourcePolicy | undefined
  savePolicy: (provider: 'native' | 'local') => Promise<void>
  canManage: boolean
  busy: boolean
  source: (resourceId: string) => void
}
/** Выбор источника и способ подтверждения по умолчанию для его кассиров. */
export function CashierSourcePicker(props: CashierSourcePickerProps) {
  const [method, setMethod] = useState<'native' | 'local' | null>(null)
  const [confirming, setConfirming] = useState(false)
  const submit = () => {
    if (props.policy === undefined || !props.canManage || props.busy) return
    const request = props.savePolicy(method ?? props.policy.provider)
    setConfirming(false); setMethod(null); void request
  }
  return <div className="cashiers-source">
    <ResourceSelectField label="Источник" actionId="receipts.cashier-access.choose" value={props.resourceId} disabled={props.busy}
      options={sourceOptions(props.sources, props.kinds)} notChosen="Выберите источник"
      loading={props.sourcesLoad?.loading === true} loadError={props.sourcesLoad?.error ?? null} {...(props.sourcesLoad === undefined ? {} : { onRetry: props.sourcesLoad.retry })}
      onChange={(value) => { setConfirming(false); setMethod(null); props.source(value) }} />
    {props.resourceId !== '' && props.policy !== undefined && <div className="cashier-access__settings">
      <h3>Способ подтверждения по умолчанию</h3>
      <SelectField label="Код для кассиров источника" actionId="receipts.cashier-access.set" value={method ?? props.policy.provider} disabled={!props.canManage || props.busy}
        options={[...(props.policy.supportsNative ? [{ value: 'native', label: 'Код кассира в источнике' }] : []), { value: 'local', label: 'Отдельный код приложения' }]}
        onChange={(value) => { if (value === 'native' || value === 'local') { setConfirming(false); setMethod(value) } }} />
      <p>Применяется к кассирам без персональной настройки. При выборе кода приложения каждому кассиру нужно задать свой код.</p>
      <Button actionId="receipts.cashier-access.set" disabled={!props.canManage || props.busy || method === null || method === props.policy.provider} onClick={() => setConfirming(true)}>Сохранить настройку источника</Button>
      {confirming && <div role="group" aria-label="Подтверждение настройки источника"><p>Изменить способ подтверждения для кассиров без персональной настройки? Ранее выданный доступ будет отозван.</p>
        <Button actionId="receipts.cashier-access.set" disabled={props.busy} onClick={submit}>Подтвердить настройку источника</Button>
        <Button actionId="receipts.cashier-access.choose" onClick={() => setConfirming(false)}>Отмена</Button>
      </div>}
    </div>}
  </div>
}
